import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const featuredArticle = articles[0];
  const gridArticles = articles.slice(1);

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-16">
        <div className="max-w-[1100px] mx-auto">
          <h2 className="text-center font-heading text-2xl md:text-3xl text-foreground-700 font-light mb-4">
            ( Latest SEO Guides )
          </h2>
          <p className="text-center text-sm text-foreground-500 mb-10 md:mb-14">
            Expert OOPBuy Spreadsheet guides to help you source smarter and track inventory better
          </p>

          <div className="flex flex-col gap-6 mb-14">
            <div className="inline-flex items-center gap-2 h-8 px-4 rounded-full bg-primary-500 text-background-50 text-xs font-semibold self-start">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              <span>Featured Guide</span>
            </div>

            <div className="flex flex-col md:flex-row gap-6 bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
              <div className="w-full md:w-[300px] lg:w-[360px] shrink-0 h-[200px] md:h-auto">
                <img
                  src={featuredArticle.imageUrl}
                  alt={featuredArticle.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-col justify-between p-5 md:p-6 flex-1">
                <div>
                  <div className="relative mb-3">
                    <span className="absolute -top-2 -left-1 text-4xl font-heading text-foreground-300 leading-none select-none">
                      &ldquo;
                    </span>
                    <h3 className="font-heading text-lg md:text-xl leading-relaxed text-foreground-800 pl-5 line-clamp-3">
                      {featuredArticle.title}
                    </h3>
                  </div>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-3 pl-5">
                    {featuredArticle.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center shrink-0">
                    <span className="text-background-50 font-heading text-sm font-bold">O</span>
                  </div>
                  <div className="flex flex-col flex-1">
                    <span className="text-xs font-semibold text-foreground-950">{featuredArticle.author}</span>
                    <span className="text-xs text-foreground-500">{featuredArticle.authorRole}</span>
                  </div>
                  <Link
                    to={`/${featuredArticle.slug}`}
                    className="flex items-center gap-1.5 h-9 px-5 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                  >
                    Read Guide
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {gridArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/${article.slug}`}
                className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-foreground-300 flex flex-col"
              >
                <div className="w-full h-44 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed flex-1 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400 font-medium">{article.authorRole}</span>
                    <span className="flex items-center gap-1 text-xs font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors">
                      Read more
                      <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}